<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="repairPlanResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" exportDisabled checkboxColumnDisabled editDisable with-custom-row-actions-first-column>
<!--                <template slot="customRowActions" slot-scope="row">-->
                <template #customRowActionsFirstColumn="{row}">
                  <b-button-group>
                    <em-button type="import"
                               title="选入维修工单"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="showRepairWorkOrderSelector(row)">
                    </em-button>
                    <em-button type="task"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="$_emWorkflowListMixin_handleApprove(row)">
                    </em-button>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoChild(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <em-modal-entity-selector ref="repairWorkOrderSelector" check-enable @checkFinish="handleRepairWorkOrderSelected"></em-modal-entity-selector>
  </div>
</template>
<script>
  // Author YuJiaBei
  // Date 2021-11-25 16:10:43
  import emWorkflowListMixin from "@/mixin/em/workflow/list";
  import emCommonGotoMixin from "@/mixin/em/common/goto";
  import emApiMixin from "@/mixin/em/common/api";
  import commonViewsUtil from "@/utils/commonViewsUtil";

  export default {
    name: "repairPlanWorkflowListView",
    mixins: [emWorkflowListMixin,emCommonGotoMixin,emApiMixin],
    data(){
      return {
        collectRepairPlanId : ""
      }
    },
    computed: {
      modelName() {``
        return this.$_emRouterHelperMixin_entityName
      }
    },
    methods:{
      gotoChild(row) {
        this.$_emGotoMixin_gotoHolderList("repairPlanDetail"
            , {rpdIdRplFilter: row.id}
            , {rpdIdRpl: row.id}, false, {})
      },
      showRepairWorkOrderSelector(repairPlan){
        this.collectRepairPlanId = repairPlan.id
        this.$refs["repairWorkOrderSelector"].setCustomVuexConfig('repairWorkOrder','repairPlanSelector',3,'repairPlanCollect')
        this.$refs["repairWorkOrderSelector"].onlyShowModal();
        this.$nextTick(() => {
          this.$refs["repairWorkOrderSelector"].doSomethingWithFiler(filter => {
            filter.$_emCustomVuexMixin_setFilterAttribute('rwoIdRplFilter', repairPlan.id);
            filter.doQuery();
          });
        })
      },
      handleRepairWorkOrderSelected(repairWorkOrderIds){
        if(repairWorkOrderIds && this.collectRepairPlanId){
          let api = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/collectRepairWorkOrder?repairWorkOrderIds=${repairWorkOrderIds}&repairPlanId=${this.collectRepairPlanId}`
          console.log("post api:",api)
          this.$_emApiMixin_post(api)
              .then(response => {
                commonViewsUtil.showSuccess(this, "选入成功")
                // //让页面刷新数据
                // this.$store.commit(`${this.entity}/setNeedToRefresh`, true, {
                //   root: true
                // })
              })
        }
      }
    }
  };
</script>